<div class="brand-moment">
  @if (image()) {
    <img class="brand-moment__image" [src]="image()" />
    <div class="brand-moment__scrim" aria-hidden="true"></div>
  }

  <div class="brand-moment__panel">
    @if (icon()) {
      <c-icon class="brand-moment__icon" [icon]="icon()" size="xxxl" />
    }
    @if (title()) {
      <h1 class="brand-moment__title">{{ title() }}</h1>
    }
    @if (description()) {
      <p class="brand-moment__description">{{ description() }}</p>
    }
    <ng-content />
  </div>
</div>
